module.exports = __webpack_public_path__ + "media/images/blogs-inner-bg-61fcf322ebc879125501632e2675e91c.png";